export default "__VITE_ASSET__9d9qFZ0x__"